import { usePatientStore } from "~/stores";

export const useVisitType = () => {
  const visitType = usePatientStore((state) => state.visitType);
  const setVisitType = usePatientStore((state) => state.setVisitType);

  return {
    visitType,
    setVisitType,
  };
};
